export const SEARCH_CONTRACT = 'contractId';
export const SEARCH_DOCUMENTATION = 'documentationId';
export const SEARCH_OFFER = 'offerId';
export const SEARCH_VISIT = 'visitId';

export default Object.freeze({
  SEARCH_CONTRACT,
  SEARCH_DOCUMENTATION,
  SEARCH_OFFER,
  SEARCH_VISIT,
});
